import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

// Initialize Firebase. Firestore lives in @/firebaseDb (static import = admin
// chunks only) and utils/loadFirestore.js (lazy, for visitor paths) so the SDK stays out
// of the visitor critical-path bundle - same reasoning as auth/storage below.
export const app = initializeApp(firebaseConfig)

// Auth and Storage are admin-only (login, account changes, uploads). They are
// loaded via dynamic import so firebase/auth (~134KB) and firebase/storage
// (~46KB) stay out of the visitor critical-path bundle. Each getter caches its
// promise, so the SDK is downloaded and initialized at most once.
let _authPromise = null
export function getAuthInstance() {
  if (!_authPromise) {
    _authPromise = import('firebase/auth').then(
      async ({ getAuth, setPersistence, browserLocalPersistence }) => {
        const auth = getAuth(app)
        await setPersistence(auth, browserLocalPersistence)
        return auth
      }
    )
    // A failed chunk load must not be cached for the session - clear so the next call retries
    _authPromise.catch(() => { _authPromise = null })
  }
  return _authPromise
}

let _storagePromise = null
export function getStorageInstance() {
  if (!_storagePromise) {
    _storagePromise = import('firebase/storage').then(({ getStorage }) => getStorage(app))
    _storagePromise.catch(() => { _storagePromise = null })
  }
  return _storagePromise
}
